module.exports = __webpack_public_path__ + "img/plan_point_badge_3.a53f7384.png";